<template>
    <div class="bookshelf">
        <div class="books" ref="books">
            <book v-for="(book, i) in books" :width="wUnit" :height="hUnit" :key="i" :name="i" :cover="book.cover" @read="$emit('read', $event)" class="book">
            </book>
        </div>
    </div>
</template>

<script>
import book from './book.vue';

export default {
    components: {
        book,
    },
    data() {
        return {
            pad: '20px',
            wUnit: 80,
            hUnit: 108,
        };
    },
    watch: {
        books: {
            immediate: true,
            handler(value) {
                if (this.$refs.books) {
                    let booksWidth = this.$refs.books.clientWidth;
                    let width = Math.floor((booksWidth - (this.max - 1) * 20 - 5) / this.max);
                    this.wUnit = width;
                    this.hUnit = width * 1.357;
                }
            }
        }
    },
    props: {
        books: {
            default() {
                return {};
            }
        },
        max: {
            default: 3,
        }
    },
}
</script>

<style lang="less" scoped>
.bookshelf {
    position: relative;
    width: 100%;
    height: 180px;
    background-image: url(../assets/shelf.jpg);
    background-repeat: repeat;
    background-size: auto 100%;
}
.books {
    overflow: hidden;
    position: absolute;
    left: 30px;
    right: 30px;
    bottom: 5px;
    text-align: left;

    .book:not(:last-of-type) {
        margin-right: 20px;
    }
}
.shelf {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    position: bottom;
}
</style>
